<template>
  <div>
    <a-alert v-if="errors.non_field_errors" type="error" class="mb-16">
      <span slot="description">
        {{ errors.non_field_errors.join('\n') }}
      </span>
    </a-alert>

    <a-alert
      v-else-if="course && course.is_group && this.isStudent"
      class="banner"
      type="info"
      banner
    >
      <p slot="description" class="banner-description">
        Kursy grupowe mogą być rezerwowane tylko przez administratora
      </p>
    </a-alert>

    <a-alert
      v-else-if="preview.reserved_slots.length"
      class="banner c-small-banner"
      type="info"
      banner
    >
      <p slot="description" class="banner-description">
        Zarezerwowano {{ totalHours }}h zajęć.
      </p>
    </a-alert>

    <a-alert
      v-else-if="hoursExceeded"
      message="Przekroczono dozwoloną liczbę rezerwacji."
      type="error"
    >
      <div slot="description">
        Przekroczono dostepną liczbę godzin dla tego kursu. Zarezerwowano
        {{ totalHours }} z {{ courseHours }} dostępnych.
      </div>
    </a-alert>
  </div>
</template>

<script>
import { Reservation } from '@/api'

export default {
  data() {
    return {
      preview: {
        reserved_slots: []
      },
      errors: {}
    }
  },
  props: {
    course: {
      type: Object,
      required: false
    },
    form: {
      type: Object,
      required: false
    }
  },
  computed: {
    totalHours() {
      return this.preview.duration
        ? (this.preview.reserved_slots.length * this.preview.duration) / 60
        : null
    },
    courseHours() {
      return this.course && this.course.hours
    },
    hoursExceeded() {
      const exceeded = this.courseHours < this.totalHours
      return exceeded
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        Reservation.previewChanges(this.form)
          .then(res => {
            this.preview = res.data
          })
          .catch(err => {
            this.preview = {
              reserved_slots: []
            }
            this.errors = err.response.data
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  margin-bottom: 8px;
}

.banner-description {
  margin-bottom: 0;
}
</style>
